/// <amd-module name="typeahead/core/message/UserExitedMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class UserExitedMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.user_exited";
    }

    constructor(private context?: IContext,
                private domElementId?: string,
                private triggerEvt?: JQueryEventObject,
                private requestId?: string) {}

    public getTopic(): string {
        return UserExitedMessage.getTopic();
    }

    public getContext(): IContext {
        return this.context;
    }

    public getDomElementId(): string {
        return this.domElementId;
    }

    public getTriggerEvt(): JQueryEventObject {
        return this.triggerEvt;
    }

    public getRequestId(): string {
        return this.requestId;
    }
}
